import React from 'react'
import PropTypes from 'prop-types'
import ClientUsers from '../ClientContacts/components/ClientUsers/ClientUsers'
import ExportButtons from '../ExportButtons/ExportButtons'
import { page as pageIndex } from '../../globals'
import { connect } from 'react-redux'
import './css/ManagementUserList.scss'
import '../ClientContacts/css/ClientsWrapper.scss'

class ManagementUserList extends React.PureComponent {
  constructor (props) {
    super(props)
    this.closeModal = this.closeModal.bind(this)
  }

  closeModal = (name) => () => {
    this.props.hideModal(name)
  }

  render () {
    const { trackData, getUserId, isEdited, isFetchingData } = this.props
    if (isFetchingData) {
      return <div>LOADING...</div>
    } else {
      return <React.Fragment>
        <ExportButtons />
        <ClientUsers
          users
          dashboard
          page={pageIndex.dashboard}
          trackData={trackData}
          sendData={getUserId}
          isEdited={isEdited}
        />
      </React.Fragment>
    }
  }

  static propTypes = {
    trackData: PropTypes.object,
    isEdited: PropTypes.bool,
    hideModal: PropTypes.func,
    getUserId: PropTypes.func,
    isFetchingData: PropTypes.bool
  }
}

export default connect(state => ({
  isFetchingData: state.clientUsers.isFetchingData
}), {})(ManagementUserList)



// WEBPACK FOOTER //
// ./src/components/ManagementUserList/ManagementUserList.js